import React from 'react';
import { ButtonGroup, Button } from 'reactstrap';
import './index.scss';
import { useTheme } from '../../../shared/hooks';

const ExanteModal = ({ toggleExanteModal }) => {
  const { theme } = useTheme();

  return (
    <div
      className="exante-modal__wrapper"
      onClick={toggleExanteModal}
      role="button"
      onKeyPress={() => null}
      tabIndex="0"
    >
      <div
        className={`exante-modal__container exante-modal__container-${
          theme === 'dark' && theme
        }`}
        onClick={(e) => {
          e.stopPropagation();
        }}
        role="button"
        onKeyPress={() => null}
        tabIndex="0"
      >
        <p>
          You are now leaving Fintex and now going onto our recommended Trading
          page EXANTE
        </p>
        <ButtonGroup className="float-right">
          <Button
            className="mr-4"
            outline
            color="primary"
            onClick={toggleExanteModal}
          >
            return
          </Button>
          <a
            href="https://exante.eu/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button color="primary">continue</Button>
          </a>
        </ButtonGroup>
      </div>
    </div>
  );
};

export default ExanteModal;
